import type React from "react";
import { ReactComponent as Svg } from "./assets/bolt-icon.svg";
import * as styles from "./Icon.module.scss";

type BoltProps = React.SVGProps<SVGSVGElement>;

export const Bolt = ({ className, ...props }: BoltProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
